// Saved (app flow §8): the reader's commonplace book. What friends shared that they want to keep,
// newest first or in Bible order, filtered by kind. Nothing here is counted for anyone else.
import { createFileRoute } from "@tanstack/react-router";
import { LinkButton } from "../../components/Button";
import { EmptyState } from "../../components/Empty";
import { PostList } from "../../components/PostList";
import { PostSkeleton } from "../../components/Skeleton";
import ui from "../../components/ui.module.css";
import { useSaved } from "../../data/queries";
import { useTitle } from "../../lib/useTitle";

export const Route = createFileRoute("/_app/saved")({ component: Saved });

function Saved() {
  useTitle("Saved");
  const { data: saved, isPending } = useSaved();
  return (
    <div className={ui.cardsPage} data-surface="cards">
      <header className={ui.cardsHead}>
        <h1 className={ui.title}>Saved</h1>
        <p className={ui.subtitle}>
          Your <em>commonplace book</em>: what friends shared that you want to keep.
        </p>
      </header>
      {isPending ? (
        <PostSkeleton count={2} />
      ) : saved && saved.length > 0 ? (
        <PostList posts={saved} label="saved posts" />
      ) : (
        <EmptyState icon="ribbon" title="Nothing saved yet." body="Press the ribbon on a post and it will wait for you here, in Bible order if you like.">
          <LinkButton to="/home" variant="secondary">
            Back to Home
          </LinkButton>
        </EmptyState>
      )}
    </div>
  );
}
